import * as S from './style'
import {
  Checkbox,
  Button,
} from 'src/components/receivement-components/components'

interface ContainerNoRelationProps {
  isCheckedNoRelation: boolean
  onRelation: (...args: any) => any,
  onCheckboxNoRelation: (...args: any) => any
}

export const ContainerRelation = ({
  isCheckedNoRelation,
  onRelation,
  onCheckboxNoRelation,
}: ContainerNoRelationProps) => (
  <S.Wrapper>
    <S.RelationItem>
      <Button title='Relacionar' onClick={onRelation} />
    </S.RelationItem>
    <S.RelationItem>
      <Checkbox
        name='nenhum'
        labelTitle='Nenhuma das opções'
        checked={isCheckedNoRelation}
        onChange={onCheckboxNoRelation}
        labelStyle={undefined}
      />
    </S.RelationItem>
  </S.Wrapper>
)
